/* Publish by EComposer at 2026-10-08 09:19:45*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-fekqah5v4od"]=  window.__ectimmers["ecom-fekqah5v4od"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-fekqah5v4od').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fekqah5v4od', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5uax1ahulni').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5uax1ahulni', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h3td8qrcxup').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h3td8qrcxup', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e2g1hv8ky').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e2g1hv8ky', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fu03sw2j6m6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fu03sw2j6m6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-clr1hoef9t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-clr1hoef9t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l7t5exyzuwl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l7t5exyzuwl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1h7rrypgya3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1h7rrypgya3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y7pzap9fk8n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y7pzap9fk8n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-64nox95q224').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-64nox95q224', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xx0v89ubg4m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xx0v89ubg4m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x3guxmbfiba').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x3guxmbfiba', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-betnrxmek0w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-betnrxmek0w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pwlo7b5oo9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pwlo7b5oo9', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-lwrbt323nz"]=  window.__ectimmers["ecom-lwrbt323nz"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-lwrbt323nz"]["tsu98zd86"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-lwrbt323nz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lwrbt323nz', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nuu532zd2wn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nuu532zd2wn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i6tu6w53pal').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i6tu6w53pal', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z40lbxtiumn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z40lbxtiumn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nodh1pwfsh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nodh1pwfsh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hqbfzdh2cx6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hqbfzdh2cx6', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mmr809yobbk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mmr809yobbk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-degzb9mjki').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-degzb9mjki', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-cxljvjrzho6"]=  window.__ectimmers["ecom-cxljvjrzho6"] || {};
if(!this.$el)return;const t=this.isLive;let e=this.$el.querySelectorAll("[ecom-modal]");const i=this.id,o=function(n){if(window.EComModal)return n();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&n()});return}let s=0;const r= window.__ectimmers["ecom-cxljvjrzho6"]["ih2in554g"] = setInterval(function(){window.EComModal?(clearInterval(r),n()):++s>=300&&clearInterval(r)},50)};e.length&&t&&o(function(){new window.EComModal(e,{gallery:!0,cssClass:["ecom-container-lightbox-"+i]})})

                    });
                    
                        document.querySelectorAll('.ecom-cxljvjrzho6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cxljvjrzho6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ygikxjmcfal').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ygikxjmcfal', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ffufo5g64gs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ffufo5g64gs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0wxeebexj2pa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0wxeebexj2pa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z99b21c5nsm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z99b21c5nsm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bev573mkrqd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bev573mkrqd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-znugiqt9nt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-znugiqt9nt', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}